module.exports = {"SEARCH_PLACEHOLDER":"Buscar...","SEARCH_FILTER_DEFAULT_TEXT":"Todas las campañas"}